module.exports = __webpack_public_path__ + "static/media/Manual_RU.bd4b870a.pdf";